import API from "../Services/API";
import Model from "./Model";
import State from "./State";

const useTemplates = (alwaysRefresh, params) => {
    return Model({
        alwaysRefresh,
        stateKey: ['templates'],
        fetchData: () => API.get('/templates'),
        returnDataKey: 'templates',
        defaultLoadingError: 'Failed to load templates.',
        saveAdditionalData: (response) => {
            response.map((template) => {
                State.putIfNotExists(['templates', template.id], template);
                return template;
            });
        },
    });
}

const useTemplate = (templateId, alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['templates', templateId],
        fetchData: () => API.get(`/templates/${templateId}`),
        returnDataKey: 'template',
        defaultLoadingError: 'Failed to load template.',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/templates/${templateId}`, data),
                        'Template updated',
                        true,
                    );
                },
            }
        },
    });
}

export {
    useTemplates,
    useTemplate,
};